import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { SaseungComponent } from './saseung.component';


const routes: Routes = [
  {
    path: 'saseung-old',
    component: SaseungComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class SaseungRoutingModule {}
